import Vue from 'vue'
import store from '@/store'
import config from 'config'
import { replaceDynamicContent } from '@/filters/replaceDynamicContent'
import {
  formatKwh,
  formatKwp,
  formatPercentage,
  formatMileage,
  formatWeight,
  formatCurrency,
  formatAmount,
} from '@/filters/formatNumbers'

import { languageText } from '@/filters/formatLocaleRelated'

// from file replaceDynamicContent
Vue.filter('replaceDynamicContent', (value, args) =>
  !value ? '' : replaceDynamicContent(value, args)
)

// from file formatNumbers
Vue.filter('formatKwh', (value, maximumFractionDigits, minimumFractionDigits) => {
  const locale = store.getters.locale
  const generalKwh = store.getters.content.general_kwh
  return formatKwh(value, generalKwh, locale, maximumFractionDigits, minimumFractionDigits)
})

Vue.filter('formatKwp', (value, maximumFractionDigits, minimumFractionDigits) => {
  const locale = store.getters.locale
  // const generalWp = store.getters.content.general_wp
  return formatKwp(
		value, 
		locale, 
		// generalWp, 
		maximumFractionDigits, 
		minimumFractionDigits
	)
})

Vue.filter('formatPercentage', (value, maximumFractionDigits, minimumFractionDigits) => {
  const locale = store.getters.locale
  return formatPercentage(value, locale, maximumFractionDigits, minimumFractionDigits)
})

Vue.filter('formatMileage', (value, maximumFractionDigits, minimumFractionDigits) => {
  const locale = store.getters.locale
  const generalKm = store.getters.content.general_km
  return formatMileage(value, locale, generalKm, maximumFractionDigits, minimumFractionDigits)
})

Vue.filter('formatWeight', (value, maximumFractionDigits, minimumFractionDigits) => {
  const locale = store.getters.locale
  const generalKg = store.getters.content.general_kg
  return formatWeight(value, locale, generalKg, maximumFractionDigits, minimumFractionDigits)
})

Vue.filter('formatCurrency', (value, fractionDigits) => {
  const locale = store.getters.locale
  const amountConnector = store.getters.content.amount_connector
  const currencyCode = config['currency.code']
  return formatCurrency(value, locale, currencyCode, fractionDigits, amountConnector)
})

Vue.filter('formatAmount', (value, maximumFractionDigits, minimumFractionDigits) => {
  return formatAmount(value, store.getters.locale, maximumFractionDigits, minimumFractionDigits)
})

Vue.filter(
  'languageText',
  (value) => store.state.data.content[`language_selection_${languageText(value)}`]
)
